import axios from 'axios'
import { i18n } from '../../../plugins/i18n'
import { castAttributesForCamelCase } from '../../../modules/string_converter'
import { setFilterValues, setFormValues, toggleFilterValues } from '../../../modules/mutations'

export const companiesMediaLibraries = {
  namespaced: true,
  state: {
    data: [],
    meta: {},
    loading: false,
    formValues: {
      stores: []
    },
    mediaLibraryIds: [],
    filteredCount: 0,
  },
  getters: {
    storeTotalCount(state) {
      return state.formValues.stores ? state.formValues.stores.length : 0
    }
  },
  mutations: {
    initMediaLibrariesState(state) {
      state.data = []
      state.meta = {}
      state.mediaLibraryIds = []
    },
    prepareConnect(state) {
      state.loading = true
    },
    readCompaniesMediaLibrariesSuccess(state, payload) {
      state.data = payload.data.map(v => {
        const media = castAttributesForCamelCase(v)
        if (media.storeCount.progress === 0
          && media.storeCount.error === 0
          && media.storeCount.complete === 0
        ) {
          media.status = 'notSet'
        } else if (media.storeCount.progress !== 0) {
          media.status = 'processing'
        } else if (media.storeCount.error !== 0) {
          media.status = 'error'
        } else {
          media.status = 'completed'
        }
        return media
      })
      state.meta = castAttributesForCamelCase(payload.meta)
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    },
    setMediaLibraryIds(state, ids) {
      state.mediaLibraryIds = ids
    },
    setMediaLibraryId(state, id) {
      if (state.mediaLibraryIds.includes(id)) {
        state.mediaLibraryIds = state.mediaLibraryIds.filter(v => v !== id)
      } else {
        state.mediaLibraryIds = [...state.mediaLibraryIds, id]
      }
    },
    setValuesForFilter(state, payload) {
      state.filteredCount = payload.meta.total_count
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    initMediaLibrariesState({ commit }) {
      commit('initMediaLibrariesState')
    },
    setMediaLibraryIds({ commit }, ids) {
      commit('setMediaLibraryIds', ids)
    },
    setMediaLibraryId({ commit }, id) {
      commit('setMediaLibraryId', id)
    },
    readCompaniesMediaLibraries({ commit, rootState }, payload = null) {
      commit('prepareConnect')

      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries.json', payload)
        .then(res => {
          commit('readCompaniesMediaLibrariesSuccess', res.data)
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    readCompaniesMediaLibrariesForFilter({ commit, rootState }, payload) {
      return axios
        .post('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries.json', payload)
        .then(res => {
          commit('setValuesForFilter', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    bulkCreate({ commit, state, rootState }, payload) {
      if (state.loading) return

      commit('prepareConnect')
      return axios.post('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries/bulk_creates.json', payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.upload', { value: i18n.t('labels.image') }) + ' ' + i18n.t('messages.delayToReflect') }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    bulkUpdate({ commit, rootState }, payload) {
      commit('prepareConnect')

      return axios.post(`/api/companies/${rootState.route.params.company_uuid}/media/libraries/bulk_updates`, payload)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.bulkUpdated', { value: i18n.t('labels.image') }) + ' ' + i18n.t('messages.delayToReflect') }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    bulkDelete({ commit, state, rootState }) {
      commit('prepareConnect')

      return axios.post(`/api/companies/${rootState.route.params.company_uuid}/media/libraries/bulk_deletes`, {
        media_library_ids: state.mediaLibraryIds
      })
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('labels.image') }) + ' ' + i18n.t('messages.delayToReflect') }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
